import React from 'react'
import PropTypes from 'prop-types'
import InputWrapper from './InputWrapper'
import { Input } from 'antd'

const TextAreaInput = ({ name, label, formItemOptions = {}, ...rest }) => {
  return (
    <InputWrapper name={name} label={label} {...formItemOptions}>
      <Input.TextArea {...rest} />
    </InputWrapper>
  )
}

TextAreaInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  formItemOptions: PropTypes.object,
}

export default TextAreaInput
